import { EducationHistoryGrade } from '~/generated/graphql';

export const prefectures = {
  hokkaido: '北海道',
  aomori: '青森県',
  iwate: '岩手県',
  miyagi: '宮城県',
  akita: '秋田県',
  yamagata: '山形県',
  fukushima: '福島県',
  ibaraki: '茨城県',
  tochigi: '栃木県',
  gunma: '群馬県',
  saitama: '埼玉県',
  chiba: '千葉県',
  tokyo: '東京都',
  kanagawa: '神奈川県',
  niigata: '新潟県',
  yamanashi: '山梨県',
  nagano: '長野県',
  toyama: '富山県',
  ishikawa: '石川県',
  fukui: '福井県',
  gifu: '岐阜県',
  shizuoka: '静岡県',
  aichi: '愛知県',
  mie: '三重県',
  shiga: '滋賀県',
  kyoto: '京都府',
  osaka: '大阪府',
  hyogo: '兵庫県',
  nara: '奈良県',
  wakayama: '和歌山県',
  tottori: '鳥取県',
  shimane: '島根県',
  okayama: '岡山県',
  hiroshima: '広島県',
  yamaguchi: '山口県',
  tokushima: '徳島県',
  kagawa: '香川県',
  ehime: '愛媛県',
  kochi: '高知県',
  fukuoka: '福岡県',
  saga: '佐賀県',
  nagasaki: '長崎県',
  kumamoto: '熊本県',
  oita: '大分県',
  miyazaki: '宮崎県',
  kagoshima: '鹿児島県',
  okinawa: '沖縄県',
  overseas: '海外',
};
export const prefecturesForProfile = prefectures;

export const prefecturesForDesiredWork = {
  ...{ all_over_japan: '全国可' },
  ...prefectures,
};

export const grades: { [key in EducationHistoryGrade]: string } = {
  b1: '学部1年',
  b2: '学部2年',
  b3: '学部3年',
  b4: '学部4年',
  b5: '学部5年',
  b6: '学部6年',
  m1: '修士1年',
  m2: '修士2年',
  d1: '博士1年',
  d2: '博士2年',
  d3: '博士3年',
  d4: '博士4年',
  s1: '高専1年',
  s2: '高専2年',
  s3: '高専3年',
  s4: '高専4年',
  s5: '高専5年',
  c1: '専門1年',
  c2: '専門2年',
  c3: '専門3年',
  c4: '専門4年',
  graduated: '既卒',
};

export const profileStatus = {
  collecting_information: '情報収集',
  looking_for_internship: 'インターン検討中',
  looking_for_job: '就活中（内定無し）',
  has_offer_and_looking_for_job: '就活中（内定有りだが、まだ探したい）',
  accepted_offer: '就活終了（内定承諾済）',
};

export default {
  resources: {
    jobs: {
      name: '求人',
      fields: {
        title: '求人タイトル',
        description: '仕事内容',
        status: 'ステータス',
      },
    },
    jobSeekers: {
      name: '求職者',
      fields: {
        prefecture: '現住所',
        status: '就活状況',
      },
      statuses: {
        collecting_information: '情報収集中',
        looking_for_internship: 'インターン検討中',
        looking_for_job: '就活中（内定無し）',
        has_offer_and_looking_for_job: '就活中（内定有りだが、まだ探したい）',
        accepted_offer: '就活終了（内定承諾済）',
      },
    },
    educationHistory: {
      name: '学歴',
      fields: {
        name: '名称',
        grade: '学年',
        faculty: '学部',
        department: '学科',
        major: '専攻',
        enrolledOn: '入学年月日',
        highSchool: '卒業高校',
      },
    },
    prefecturesForProfile,
    prefecturesForDesiredWork,
  },
};
